import React, { useState } from 'react';
import { Modal } from 'antd';
import { Widget, MasterDetailForm, Button, FormSubmitButton } from '@digital/ui';
import { importarPlanilha } from '@app/api/planilhaRateio';
import { UploadFile } from '@app/components';
import './modal.css';

export interface FormImportarPlanilhaProps {
  planilhaRateioId: string;
  CallbackImportarPlanilha: any;
}

const FormImportarPlanilha = (props: FormImportarPlanilhaProps) => {
  const { CallbackImportarPlanilha, planilhaRateioId } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [fileArquivo, setfileArquivo] = useState<boolean>(false);

  const importarPlanilhaRateio = (values: any) => {
    var form = new FormData();
    form.append('fileArquivo', values['fileArquivo']);
    form.append('id', planilhaRateioId);
    importarPlanilha(form).then(data => {
      if (data) {
        setfileArquivo(true);
        setfileArquivo(false);
        setShowModal(false);
        CallbackImportarPlanilha();
      }
    });
  };

  return (
    <>
      <Button
        id={'btnNovaPlanilha'}
        type="link"
        icon="data-data_recovery"
        onClick={() => {
          setShowModal(true);
        }}>
        Importar Excel
      </Button>
      <Modal
        visible={showModal}
        width={620}
        title="Importar Excel"
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          onSubmit={data => importarPlanilhaRateio(data)}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setfileArquivo(true);
                setfileArquivo(false);
                setShowModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton noIcon={true} title="Enviar" type="primary" />,
          ]}>
          <Widget>
            <UploadFile
              accept={'.xlsx'}
              nameFormData={'fileArquivo'}
              label={'Arquivo Importação'}
              hasFile={fileArquivo}
              selectedItem={fileArquivo}
            />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default FormImportarPlanilha;
